// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    $("body").on("click", ".product-upsell__show-more-options", function (e) {
      const target = e.target;
      const fieldset = target.closest("fieldset");
      const show_more = fieldset.querySelectorAll(
        ".product-upsell__more-option"
      );
      target.style.display = "none";
      show_more.forEach((sm) =>
        sm.classList.remove("product-upsell__more-option")
      );
    });

    $(document).on("change", ".product-upsell__radio", function (e) {
      const target = e.target;
      const form = target.closest(".upsell-form-action");
      const checked = Array.from(form.querySelectorAll("input:checked")).map(
        (input) => input.value
      );
      const json = JSON.parse(
        form.querySelector("[data-json-product]").innerText
      );

      const selectedVariant = json.find(
        (variant) =>
          variant.option1 == checked[0] && variant.option2 == checked[1]
      );

      if (target.classList.contains("swatch")) {
        const variantSizes = json.filter(
          (variant) => variant.option1 == checked[0]
        );

        const sizes = Array.from(
          form.querySelectorAll(
            ".product-upsell__fieldset:nth-of-type(2) input"
          )
        );

        let firstAvailableVariant = null,
          firstAvailableInput = null;
        variantSizes.forEach((variant) => {
          const size = sizes.find((s) => s.value == variant.option2);
          if (variant.available) {
            if (!firstAvailableVariant) {
              firstAvailableVariant = variant;
              firstAvailableInput = size;
            }
            size.dataset.availability = "available";
            size.removeAttribute("disabled");
          } else {
            size.dataset.availability = "soldout";
            size.setAttribute("disabled", "disabled");
          }
        });
        if (!firstAvailableVariant) {
          firstAvailableInput = sizes[0];
          firstAvailableVariant = variantSizes[0];
        }
        firstAvailableInput.checked = true;

        const input = form.querySelector(".variantIdAddCart");
        input.value = firstAvailableVariant.id;

        const submit = form.querySelector(".recommend-btn-add");
        if (firstAvailableVariant.available) {
          submit.removeAttribute("disabled");
          submit.innerText = "COMPRAR";
        } else {
          submit.setAttribute("disabled", "disabled");
          submit.innerText = "ESGOTADO";
        }
      } else {
        const input = form.querySelector(".variantIdAddCart");
        input.value = selectedVariant.id;
      }
    });

    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__label")) {
        const target = e.target;
        const parentFieldset = target.closest("fieldset");
        parentFieldset
          .querySelector("label.checked")
          ?.classList.remove("checked");
        target.classList.add("checked");

        const compreJunto = target.closest(".product-item--compre-junto");
        const form = target.closest(".card-quickbuy--form");

        const isKit = compreJunto
          ? JSON.parse(compreJunto.dataset.variantIds).length == 2
          : form?.classList.contains("card-quickbuy--kit");

        const isSoldout = compreJunto
          ? compreJunto.querySelectorAll(
              ".card-quickbuy__label.soldout.checked"
            ).length > 0
          : target.classList.contains("soldout");

        // Lógica do quickbuy para o módulo de compre junto
        if (compreJunto) {
          // Desabilita o card de produto caso algum item selecionado esteja soldout
          const addButton = compreJunto.querySelector(
            ".card-product__add-button"
          );

          if (
            (isSoldout && compreJunto.classList.contains("checked")) ||
            (!isSoldout && !compreJunto.classList.contains("checked"))
          ) {
            $(addButton).trigger("click");
          }

          const fieldset = target.closest("fieldset");
          const variantIds = JSON.parse(compreJunto.dataset.variantIds);

          const variantIdsNew = variantIds.map((v) => {
            if (fieldset.dataset.kit == v.kit || variantIds.length == 1) {
              return {
                ...v,
                id: parseInt(target.dataset.variantId),
              };
            }
            return v;
          });

          compreJunto.setAttribute(
            "data-variant-ids",
            JSON.stringify(variantIdsNew)
          );
        } else {
          const submitButton = form.querySelector(".card-quickbuy__submit");
          if (submitButton) {
            if (!isKit) {
              if (isSoldout) {
                submitButton.textContent = window.card_soldout;
                submitButton.disabled = true;
              } else {
                submitButton.textContent = window.card_add_to_cart;
                submitButton.disabled = false;
              }

              $(submitButton).show();
            } else {
              const fieldsets = form.querySelectorAll("fieldset");
              const selectedRadios = form.querySelectorAll("label.checked");

              let isSoldout = false;
              if (selectedRadios.length == fieldsets.length) {
                selectedRadios.forEach((radio) => {
                  if (radio.classList.contains("soldout")) {
                    isSoldout = true;
                  }
                });

                if (isSoldout) {
                  submitButton.textContent = window.card_soldout;
                  submitButton.disabled = true;
                } else {
                  submitButton.textContent = window.card_add_to_cart;
                  submitButton.disabled = false;
                }

                $(submitButton).show();
              }
            }
          }
        }
      }
    });

    $("body").click(function (e) {
      if (e.target.classList.contains("card-quickbuy__submit")) {
        const submitButton = e.target;
        e.preventDefault();
        submitButton.disabled = true;
        const form = submitButton.closest(".card-quickbuy--form");
        const isKit = form.classList.contains("card-quickbuy--kit");
        let formData = { items: [] };

        if (!isKit) {
          const input = form.querySelector("label.checked");
          const isSoldout = input.classList.contains("soldout");

          if (!isSoldout) {
            formData.items.push({ id: input.dataset.variantId, quantity: 1 });
          }
        } else {
          const fieldsets = form.querySelectorAll("fieldset");
          const inputs = form.querySelectorAll("label.checked:not(.soldout)");

          if (inputs.length == fieldsets.length) {
            inputs.forEach((input) => {
              formData.items.push({ id: input.dataset.variantId, quantity: 1 });
            });
          }
        }

        if (formData.items.length > 0) {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              Shopify.getCart((cart) => {
                window.updateCart(cart);
              });
              submitButton.disabled = false;
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    });
  });
})(jQuery);

(function () {
  const THRESHOLD = 20;
  let lastY = window.pageYOffset || 0;
  let downAccum = 0;

  let ignoreWindowScrollUntil = 0;
  function markIgnoreIfInsideQuickSearch(e) {
    const box =
      e.target &&
      e.target.closest &&
      e.target.closest(
        ".quickSearchResultsWrap, .quickSearchResultsBlock, .quickSearchResultsWidget, .quickSearchResults"
      );
    if (box) ignoreWindowScrollUntil = Date.now() + 250;
  }
  window.addEventListener("wheel", markIgnoreIfInsideQuickSearch, {
    passive: true,
    capture: true,
  });
  window.addEventListener("touchmove", markIgnoreIfInsideQuickSearch, {
    passive: true,
    capture: true,
  });

  function getSearchInput() {
    return (
      document.querySelector('.header input[type="search"]') ||
      document.querySelector('.search-modal input[type="search"]') ||
      document.querySelector('input[type="search"][name="q"]') ||
      document.querySelector('input[name="q"]') ||
      document.querySelector('input[type="search"]')
    );
  }

  function isWrapperOpen() {
    const wrap = document.querySelector(".quickSearchResultsWrap");
    if (!wrap) return false;

    if (
      wrap.classList.contains("is-show") ||
      wrap.classList.contains("is-open")
    )
      return true;

    if (wrap.hasAttribute("hidden") || wrap.classList.contains("hidden"))
      return false;

    const st = window.getComputedStyle(wrap);
    return (
      st.display !== "none" && st.visibility !== "hidden" && st.opacity !== "0"
    );
  }

  function isSearchFocused() {
    const input = getSearchInput();
    return !!input && document.activeElement === input;
  }

  function resetSearchOnly() {
    const input = getSearchInput();
    if (!input) return;

    input.value = "";
    input.setAttribute("value", "");

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    input.blur();

    const form = input.closest("form");
    if (form) form.reset();

    const details = input.closest("details[open]");
    if (details) details.removeAttribute("open");
  }

  function closeQuickSearch() {
    const closeBtn =
      document.querySelector(".header-search-popup-close") ||
      document.querySelector("[data-search-close]") ||
      document.querySelector(".search-modal__close-button");

    if (closeBtn) closeBtn.click();

    document
      .querySelectorAll(
        ".quickSearchResultsWrap.is-show, .quickSearchResultsWrap.is-open, .quickSearchResultsBlock.is-show"
      )
      .forEach((el) => el.classList.remove("is-show", "is-open"));

    document.body.classList.remove(
      "overflow-hidden",
      "open-search",
      "search-open"
    );

    resetSearchOnly();

    downAccum = 0;
  }

  function onScroll() {
    if (Date.now() < ignoreWindowScrollUntil) {
      lastY = window.pageYOffset || 0;
      return;
    }

    const y = window.pageYOffset || 0;
    const delta = y - lastY;

    if (delta > 0) downAccum += delta;
    else downAccum = 0;

    if (downAccum >= THRESHOLD && (isWrapperOpen() || isSearchFocused())) {
      closeQuickSearch();
    }

    lastY = y;
  }

  window.addEventListener("scroll", onScroll, { passive: true });
})();

window.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get("page"), 10);

  if (body.classList.contains("template-collection") && page >= 2) {
    const targetElement = document.querySelector(".collection-banner-adv");
    if (targetElement) {
      const offset = 180;
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  }
});
